module.exports = {
  userRoleTypes: JSON.parse(process.env.userRoleTypes),
  roles: JSON.parse(process.env.roles),
  token: JSON.parse(process.env.token),
  FileType: {
    docType: [
      'application/pdf', // pdf
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // excel
      'text/csv', // csv
      'application/vnd.ms-excel',
    ],
    imageType: [
      'image/jpeg', // jpg / jpeg
      'image/png', // png
    ],
    txtType: ['text/plain'],
    onlyCSV: [
      'text/csv', // csv
    ],
    onlyXls: [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // excel
      'application/vnd.ms-excel',
    ],
    bookImage: [
      'application/pdf', // pdf
      'image/jpeg', // jpg / jpeg
      'image/png', // png
    ],
  },
  // limit to 2MB
  FILE_SIZE_LIMIT: 10,
  dataReports: [
    { key: 'xrf_basic_details', value: 'XRF Basic Details' },
    { key: 'xrf_summary', value: 'XRF Summary' },
    { key: 'oba_details', value: 'OBA Details' },
    {
      key: 'paper_characteristic_summary',
      value: 'Paper Characteristic Summary',
    },
  ],
  //category analysis array of object
  analysisCategory: [
    { key: 'all', value: 'All' },
    { key: 'physical_characteristics', value: 'Physical Characteristics' },
    { key: 'xrf', value: 'XRF' },
    { key: 'micrometer', value: 'Micrometer' },
    // { key: 'glossmeter', value: 'Glossmeter' },
    { key: 'photospectrometer', value: 'Photospectrometer' },
    { key: 'mount_characteristics', value: 'Mount Characteristics' },
    {
      key: 'mount_condition_characteristics',
      value: 'Mount Condition Characteristics',
    },
    // { key: 'basic_photos', value: 'Catalog Report (basic report)' }, //comment as client's requirement
  ],
  PAPER_WEIGHT: [
    { key: '1', value: 'Single Weight' },
    { key: '2', value: 'Double Weight' },
    { key: '3', value: 'Undetermined' },
  ],
  OBA: [
    { key: '1', value: 'Yes' },
    { key: '0', value: 'No' },
  ],
  PAPER_SHEEN: [
    { key: '1', value: 'Glossy' },
    { key: '2', value: 'Semi Gloss' },
    { key: '3', value: 'Matte' },
  ],
  PAPER_TEXTURE: [{ key: '', value: 'No Value' }],
  STATUS: [
    {
      key: 'draft',
      value: 'Pending',
    },
    {
      key: 'in_progress',
      value: 'In Progress',
    },
    {
      key: 'published',
      value: 'Completed',
    },
    {
      key: 'failed',
      value: 'Failed',
    },
  ],
  ADDITIONAL_COL: [
    { key: 'id', value: 'ID' },
    { key: 'authenticity_confidences', value: 'Authenticity confidence value', checked: true },
    { key: 'negative_id', value: 'Negative/image' },
    { key: 'negative_thumbnail', value: 'Negative Thumbnail' },
    { key: 'neg_date_range', value: 'Negative date' },
    { key: 'portfolio_info', value: 'Portfolio' },
    { key: 'date_confidence', value: 'Date confidence value', checked: true },
    { key: 'signature_recto_text', value: 'Signature Recto Text' },
    { key: 'signature_verso_text', value: 'Signature Verso Text' },
    { key: 'annotations_recto_handwriting', value: 'Annotations Recto Handwriting' },
    { key: 'annotations_verso_handwriting', value: 'Annotations Verso Handwriting' },
    { key: 'stamp_verso_handwriting', value: 'Stamp Verso Handwriting' },
    { key: 'image_size', value: 'Image size' },
    { key: 'print_date', value: 'Print date', checked: true },
    { key: 'stamp_name', value: 'Stamp' },
    { key: 'stamp_size', value: 'Stamp size' },
    { key: 'standard_stamp_size', value: 'Standard Stamp size' },
    { key: 'avg_dmin_ba_sr', value: 'Ba/Sr', checked: true },
  ],

  ADDITIONAL_COL_1: [
    { key: 'id', value: 'ID' },
    { key: 'authenticity_confidences', value: 'Authenticity confidence value', checked: true },
    { key: 'authenticity_confidence_reason', value: 'Authenticity Confidence Reason' },
    { key: 'negative_id', value: 'Negative/image' },
    { key: 'neg_date_range', value: 'Negative date' },
    { key: 'portfolio_info', value: 'Portfolio' },
    { key: 'date_confidence', value: 'Date confidence value', checked: true },
    { key: 'date_confidence_reason', value: 'Date Confidence Reason' },
    { key: 'annotations_recto_handwriting', value: 'Annotations Recto Handwriting' },
    { key: 'annotations_verso_handwriting', value: 'Annotations Verso Handwriting' },
    { key: 'stamp_verso_handwriting', value: 'Stamp Verso Handwriting' },
    { key: 'image_size', value: 'Image size' },
    { key: 'print_date_range', value: 'Print date', checked: true },
    { key: 'stamp_name', value: 'Stamp' },
    { key: 'stamp_size', value: 'Stamp size' },
    { key: 'standard_stamp_size', value: 'Standard Stamp size' },
    { key: 'avg_dmin_ba', value: 'Absolute Ba', checked: true },
    { key: 'avg_dmin_sr', value: 'Absolute Sr', checked: true },
    { key: 'presence_of_selenium_se', value: 'Selenium yes/no', checked: true },
    { key: 'avg_dmin_ba_sr', value: 'Ba/Sr', checked: true },
    { key: 'avg_dmin_ba_sr_range', value: 'Ba/Sr range' },
    { key: 'paper_sheen', value: 'Gloss' },
    { key: 'paper_weight', value: 'Paper weight' },
    { key: 'mount_thickness', value: 'Mount Thickness' },
    { key: 'paper_group', value: 'Paper group' },
    { key: 'oba', value: 'oba', checked: true },
    { key: 'title', value: 'Title', checked: true },
  ],
  PRESENCE_OF_SELENIUM: [
    { key: 'Yes', value: 'Yes' },
    { key: 'No', value: 'No' },
  ],
};
